import { Component, OnInit, TemplateRef } from '@angular/core';
import { BsModalService } from 'ngx-bootstrap/modal';
import { ExpertCalibration_Interface } from 'src/app/Interface/ExpertCalibration_Interface';
import { Kartable_Device_Point_Interface } from 'src/app/Interface/Kartable_Device_Point_Interface';
import { User_Interface } from 'src/app/Interface/User_Interface';
import { KartableService } from 'src/app/Service/Kartable/Kartable.service';
import { NavService } from 'src/app/Service/Nav/Nav.service';
import { UserService } from 'src/app/Service/User/User.service';
import * as XLSX from 'xlsx';

@Component({
  selector: 'app-KartableDevicePoint2',
  templateUrl: './KartableDevicePoint2.component.html',
  styleUrls: ['./KartableDevicePoint2.component.scss']
})
export class KartableDevicePoint2Component implements OnInit {

  Token:String=""

  CustomerName:String="" 
  DeviceName:String="" 
  SubmitPeriodDate:String="1"
  SubmitAccept:String="0"
  LocationOfCalibration:String="0"
  page=0

  Procssing:boolean=false



  constructor(
    private User_Service:UserService,
    private Nav_Service:NavService,
    private Kartable_Service:KartableService,
    private modalService: BsModalService
  ) { }


  DataList_Kartable:Array<Kartable_Device_Point_Interface>=[]
  DataList_Kartable_Option:Array<User_Interface>=[]

  ngOnInit() {
    this.Token=localStorage.getItem('Daro_User_Token');

    this.Nav_Service.CheckValidPage(this.Token,2182).subscribe(
      data=>{
        this.Read_User_Option()
      }
      ,error=>{
        localStorage.clear()
        location.reload();
      }
    )


  }

  Read_User_Option(){
    this.Procssing=true
    this.User_Service.GetRecord(this.Token).subscribe(
      data=>{
        this.DataList_Kartable_Option=data
        this.Procssing=false
      },error=>{
        localStorage.clear()
        location.reload();

      }
    )
  }

  ReadData_Point(StartSearchDate,EndSearchDate){
    this.Procssing=true
    this.Kartable_Service.GetDevicePoint2(this.Token,
      StartSearchDate,
      EndSearchDate,
      this.DeviceName,
      this.CustomerName,
      Number(this.SubmitPeriodDate),
      Number(this.SubmitAccept),
      Number(this.LocationOfCalibration),
      this.ExpertCalibration).subscribe(
      data=>{
        this.DataList_Kartable=data
        this.Procssing=false
      },error=>{
        localStorage.clear()
        location.reload();

      }
    )
  }

  exportexcel(): void {
    /* table id is passed over here */
    let element = document.getElementById('excel-table');
    const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);

    /* generate workbook and add the worksheet */
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

    /* save to file */
    XLSX.writeFile(wb, "BehfaPoint.xlsx");

  }


  ExpertCalibration:String=''
  OnGet_ExpertCalibration_Action(model: Array<ExpertCalibration_Interface>)
  {
    this.ExpertCalibration = "-1"
    for (let item of model)
    {
      this.ExpertCalibration=this.ExpertCalibration+","+item.id
    }

    if (model.length == 0)
      this.ExpertCalibration=""

  }

  modalRef_Baznegari:any
  Datalist_Baznegari:Array<string>=[]
  openModal(template: TemplateRef<any>, Record:Array<string>) {

    this.Datalist_Baznegari = Record
    this.modalRef_Baznegari = this.modalService.show(template);
  }



  modalRef_Baznegari1:any
  Datalist_Baznegari1:Array<string>=[]
  openModal1(template: TemplateRef<any>, Record:Array<string>) {

    this.Datalist_Baznegari1 = Record
    this.modalRef_Baznegari1 = this.modalService.show(template);
  }

}
